import { rem } from 'polished';
import styled, { css } from 'styled-components';
export const itemStyles = css `
  border: none;
  flex-shrink: 0;
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0 ${rem(12)};
`;
export default styled.div `
  ${itemStyles}
`;
